import { createFileRoute } from '@tanstack/react-router';
import { PreferencesSettingsPage } from 'src/modules/settings/components/pages/preferences-settings.page';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';

export const Route = createFileRoute('/settings/preferences')({
  component: PreferencesSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
